/**
 * Newsletter LP Rebajas/WhatsApp — envia via form 'customer' e redireciona para o grupo.
 */
(function () {
  const form = document.querySelector('.lp-form[data-rebajas-tag]');
  if (!form) return;

  const whatsappUrl = form.dataset.rebajasWhatsapp || '';
  const customerTag = form.dataset.rebajasTag || '';
  const originNote = form.dataset.rebajasOrigin || '';
  const errorMessage = form.dataset.rebajasError || 'Request failed.';
  const locale = form.dataset.rebajasLocale === 'es' ? 'es' : 'pt';
  const tagsInput = form.querySelector('#lp-tags');
  const bodyInput = form.querySelector('#lp-body');
  const phoneInput = form.querySelector('#lp-telefone');
  const errorEl = form.querySelector('#lp-form-error');
  const submitBtn = form.querySelector('.lp-btn-cta');

  const PHONE_GROUPS = {
    pt: [3, 3, 3, 3],
    es: [2, 3, 3, 3],
  };

  const TERMS_ACCEPTED = {
    pt: 'Aceitou termos: sim',
    es: 'Aceptó términos: sí',
  };

  const PHONE_LABEL = {
    pt: 'Telefone',
    es: 'Teléfono',
  };

  let submitting = false;

  function ensureHiddenInput(name, value) {
    let input = form.querySelector(`input[name="${CSS.escape(name)}"]`);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    input.value = value;
  }

  function formatPhone(digits, phoneLocale) {
    const groups = PHONE_GROUPS[phoneLocale] || PHONE_GROUPS.pt;
    const maxDigits = groups.reduce((sum, size) => sum + size, 0);
    const limited = digits.replace(/\D/g, '').slice(0, maxDigits);
    if (!limited) return '';

    let formatted = '+';
    let offset = 0;

    for (let index = 0; index < groups.length; index += 1) {
      const chunk = limited.slice(offset, offset + groups[index]);
      if (!chunk) break;
      if (index > 0) formatted += ' ';
      formatted += chunk;
      offset += groups[index];
    }

    return formatted;
  }

  function bindPhoneMask() {
    if (!phoneInput) return;

    const applyFormat = () => {
      const digits = phoneInput.value.replace(/\D/g, '');
      const formatted = formatPhone(digits, locale);
      phoneInput.value = formatted;

      if (formatted && document.activeElement === phoneInput) {
        phoneInput.setSelectionRange(formatted.length, formatted.length);
      }
    };

    phoneInput.addEventListener('input', applyFormat);
    phoneInput.addEventListener('blur', applyFormat);
    phoneInput.addEventListener('paste', () => {
      requestAnimationFrame(applyFormat);
    });
  }

  bindPhoneMask();

  form.addEventListener('submit', (event) => {
    event.preventDefault();
    if (submitting) return;

    const emailInput = form.querySelector('[name="contact[email]"]');
    const email = (emailInput?.value || '').trim();
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      emailInput?.focus();
      return;
    }

    submitting = true;
    if (submitBtn) submitBtn.disabled = true;
    if (errorEl) errorEl.hidden = true;

    ensureHiddenInput('customer[accepts_marketing]', 'true');
    ensureHiddenInput('contact[accepts_marketing]', 'true');

    if (tagsInput) tagsInput.value = customerTag;

    const rawPhone = (phoneInput?.value || '').trim();
    const phone = rawPhone ? formatPhone(rawPhone, locale) : '';
    if (phoneInput && phone) phoneInput.value = phone;

    const bodyParts = [originNote, TERMS_ACCEPTED[locale]];
    if (phone) bodyParts.push(`${PHONE_LABEL[locale]}: ${phone}`);
    if (bodyInput) bodyInput.value = bodyParts.filter(Boolean).join('\n');

    const action = form.getAttribute('action') || '/contact';
    const data = new FormData(form);

    fetch(action, {
      method: 'POST',
      body: data,
      credentials: 'same-origin',
      redirect: 'follow',
      headers: {
        Accept: 'text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8',
      },
    })
      .then(async (response) => {
        let html = '';
        try {
          html = await response.text();
        } catch (_) {
          /* resposta opaca após redirect — cadastro costuma ter sido aceite */
        }

        const clientError = response.status >= 400 && response.status < 500;
        const htmlShowsError =
          /class="errors"/i.test(html) ||
          /form-message--error/i.test(html) ||
          /form__message--error/i.test(html);

        if (clientError && htmlShowsError) {
          throw new Error('validation');
        }

        if (whatsappUrl) {
          window.location.href = whatsappUrl;
          return;
        }

        submitting = false;
        if (submitBtn) submitBtn.disabled = false;
      })
      .catch((error) => {
        if (error?.message === 'validation') {
          submitting = false;
          if (submitBtn) submitBtn.disabled = false;
          if (errorEl) {
            errorEl.textContent = errorMessage;
            errorEl.hidden = false;
          }
          return;
        }

        /* Falha de rede: ainda tenta WhatsApp se o POST puder ter sido processado */
        if (whatsappUrl) {
          window.location.href = whatsappUrl;
          return;
        }

        submitting = false;
        if (submitBtn) submitBtn.disabled = false;
        if (errorEl) {
          errorEl.textContent = errorMessage;
          errorEl.hidden = false;
        }
      });
  });
})();
